import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

//Lenis
import Lenis from '@studio-freight/lenis'

const lenis = new Lenis()

lenis.on('scroll', (e) => {
  //console.log(e)
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


$("document").ready(function() {
    if($('.agl_main').length>0) { 

        $('.agl_main .checkbox').click(function() {
          $('.agl_main').toggleClass("active");
          return false;
        });
      }

  
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var targetHash = this.hash;
            var decodedHash = decodeURIComponent(targetHash);
            var target = $(decodedHash);
            
            target = target.length ? target : $('[name=' + decodedHash.slice(1) +']');
            
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 200
                }, 1000);
                return false;
            }
        }
    });

});